import {
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
//import useStyles from "./AccSubCategory.css";
import useStyles from "../MasterData.css";
import translation from "../../../i18n/i18.json";
import { MasterDataService } from "../../../services/MasterDataService";
import { AccSubCat } from "../../../models/Master/AccSubCat";
import AllActions from "../../../actions";
import { useDispatch } from "react-redux";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AccSubCategoryAddDialog from "./AccSubCategoryAddDialog";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { Company } from "../../../models/Company";
import { ReconAC } from "../../../models/ReconAC";
import SearchIcon from "@material-ui/icons/Search";
import { AccSubCategoryFilter } from "../../../models/Master/AccSubCategoryFilter";
import { InforDisplyaDuration, MasterDataConstants } from "../../../constants/AppConstants";
import { VendorDetailService } from "../../../services/VendorDetailService";

export default function AccSubCategory() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const initialState: AccSubCat = {
    id: 0,
    subCategoryCode: "",
    subcategoryName: "",
    companyCode: "",
    accountGroupCode: "",
    isActive: true,
  };
  const [selectedData, setSelectedData] = useState<AccSubCat>(initialState);
  const [tableRowData, setTableRowData] = useState<AccSubCat[]>([]);
  const tableColumnData = [
    { name: translation.master_acc_subcat_code },
    { name: translation.master_acc_subcat_name },
    { name: translation.master_acc_subcat_companycode },
    { name: translation.master_acc_subcat_accgropucode },
    { name: translation.master_acc_subcat_isactive },
  ];
  const rowsPerPage = MasterDataConstants.TablerowCount;
  const [page, setPage] = React.useState(0);
  const [rowCount, setRowCount] = React.useState(0);
  const [isTableLoading, setIsTableLoading] = React.useState(false);
  const [filterParams, setFilterParams] = useState<AccSubCategoryFilter>({
    pageNo: page,
    rowCount: rowsPerPage,
    subCategoryCode: "",
    subcategoryName: "",
    companyCode: "",
    accountGroupCode: "",
    isActive: true,
  });
  const [companyCodeList, setCompanyCodeList] = useState(Array<Company>());
  const [reconAcList, setReconAcList] = useState(Array<ReconAC>());

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(AllActions.infoActions.openInforSuccess(message, InforDisplyaDuration.common));
      } else {
        dispatch(AllActions.infoActions.openInforError(message, InforDisplyaDuration.common));
      }
    }
  };

  const onEditClick = (listItem: AccSubCat) => {
    setSelectedData(listItem);
    setIsUpdateOpen(true);
  };

  const onDeleteClick = (listItem: AccSubCat) => {
    dispatch(
      AllActions.alertDialogActions.openAlertDialog(
        translation.master_delete_con_title,
        translation.master_delete_con_msg,
        translation.master_delete_con_yesbtn,
        function () {
          setSelectedData(listItem);
          prepareForRequest();
          MasterDataService.deleteAccSubCategory(
            listItem,
            function (accSubCategory: AccSubCat) {
              compeleteRequest(
                true,
                translation.master_subcat_dialog_delete_suc
              );
              dispatch(AllActions.alertDialogActions.closeAlertDialog());
            },
            function (error: Error) {
              compeleteRequest(false, translation.master_subcat_delete_err);
            }
          );
        },
        translation.master_delete_con_nobtn,
        function () {
          dispatch(AllActions.alertDialogActions.closeAlertDialog());
        }
      )
    );
  };

  const handleAddTableData = (e: any) => {
    setSelectedData(initialState);
    setIsUpdateOpen(true);
  };

  // const handleOnDataUpdate = (e:any) => {
  //     setIsUpdateOpen(false);
  // };

  const handleUpdateDialogClose = (e: any) => {
    setIsUpdateOpen(false);
  };

  const handleFilter = (e: any) => {
    setFilterParams({ ...filterParams, pageNo: 1 });
    setPage(0);
    setIsTableLoading(true);
    //getSubCategoryList();
  };

  const handleChangePage = (event: any, newPage: number) => {
    setFilterParams({ ...filterParams, pageNo: newPage + 1 });
    setPage(newPage);
    setIsTableLoading(true);
  };

  const handleChange = (input: string) => (e: any) => {
    let val: any = e.target.value;
    if (e.target.type === "checkbox") {
      setFilterParams({ ...filterParams!, [input]: e.target.checked });
    } else if (input === "companyCode") {
      setFilterParams({
        ...filterParams,
        companyCode: e.target.value,
        accountGroupCode: "",
      });
    } else {
      setFilterParams({ ...filterParams!, [input]: val });
    }
  };

  const getSubCategoryList = () => {
    prepareForRequest();
    MasterDataService.getAccSubCategries(
      filterParams,
      function (accSubCategories: Array<AccSubCat>) {
        setTableRowData(accSubCategories);
        compeleteRequest(true);
        setIsTableLoading(false);
      },
      function (error: Error) {
        setTableRowData([]);
        compeleteRequest(false, translation.master_acc_subcat_list_error);
        setIsTableLoading(false);
      }
    );
  };

  // useEffect(() =>   getSubCategoryList(), [page]);

  useEffect(() => {
    if (isTableLoading) {
      getSubCategoryList();
    }
  }, [isTableLoading]);

  useEffect(() => {
    setFilterParams((state) => {
      return {
        ...filterParams,
        pageNo: 1,
      };
    });
    setPage(0);
    setIsTableLoading(true);
    //getSubCategoryList();

    let data = [
      {
        id: 1,
        subCategoryCode: "A00",
        subcategoryName: "A00 Name",
        companyCode: "COM A",
        accountGroupCode: "GRP A",
        isActive: true,
      },
      {
        id: 2,
        subCategoryCode: "A01",
        subcategoryName: "A01 Name",
        companyCode: "COM A1",
        accountGroupCode: "GRP A1",
        isActive: true,
      },
      {
        id: 3,
        subCategoryCode: "A02",
        subcategoryName: "A02 Name",
        companyCode: "COM A2",
        accountGroupCode: "GRP A2",
        isActive: true,
      },
    ];
    setTableRowData(data);

    VendorDetailService.getCompany(
      function (companyData: Array<Company>) {
        companyData.splice(0, 0, { code: "", countryCode:"", name: "None", isWhtAvailable:false });
        setCompanyCodeList(companyData);
      },
      function (error: Error) {
        setCompanyCodeList([]);
      }
    );
  }, []);

  useEffect(() => {
    if (filterParams.companyCode && filterParams.companyCode !== "") {
      prepareForRequest();
      VendorDetailService.getReconAC(
        filterParams.companyCode,
        "",
        function (reconACData: Array<ReconAC>) {
          setReconAcList(reconACData);
          compeleteRequest(true);
        },
        function (error: Error) {
          setCompanyCodeList([]);
          compeleteRequest(false);
        }
      );
    }
  }, [filterParams.companyCode]);

  return (
    <div>
      <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} style={{margin: "0 0 30px 0 !important", float: "left",}}>
        <div className={classes.addNewBtnWrapper}>
          <Button onClick={handleAddTableData} style={{right: "18px", position: "absolute", top: "80px"}}>
            <AddCircleIcon></AddCircleIcon>
            {translation.master_table_subcat_addbtntxt}
          </Button>
        </div>
      </Grid>

      <div>
        {/* Filter area START */}
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
        <Grid
          container
          spacing={2}
          item
          xs={12}
          sm={12}
          md={1}
          lg={1}
          className={classes.filterheader}
        >
          Filter
        </Grid>
        <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>
          <div className={classes.filterWrapper}>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.master_acc_subcat_code}
              </label>
              <div className={classes.inputWrapperFilter}>
                <TextField
                  variant="outlined"
                  onChange={handleChange("subCategoryCode")}
                ></TextField>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.master_acc_subcat_name}
              </label>
              <div className={classes.inputWrapperFilter}>
                <TextField
                  variant="outlined"
                  onChange={handleChange("subcategoryName")}
                ></TextField>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.master_acc_subcat_companycode}
              </label>
              <div className={classes.inputWrapperFilter}>
                <Select
                  variant="outlined"
                  value={filterParams.companyCode || ""}
                  onChange={handleChange("companyCode")}
                >
                  {companyCodeList.map((obj, index) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.master_acc_subcat_accgropucode}
              </label>
              <div className={classes.inputWrapperFilter}>
                <Select
                  variant="outlined"
                  value={filterParams.accountGroupCode || ""}
                  onChange={handleChange("accountGroupCode")}
                >
                  {reconAcList.map((obj, index) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.master_acc_subcat_isactive}
              </label>
              <div className={classes.inputWrapperFilter}>
                <Switch
                  checked={filterParams!.isActive}
                  onChange={handleChange("isActive")}
                ></Switch>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <div className={classes.searchBtnWrapper}>
                <Button onClick={handleFilter} style={{ float: "left" }}>
                  <SearchIcon></SearchIcon>
                  {translation.dashboard_filternm_btntxt}
                </Button>
              </div>
            </div>
          </div>
        </Grid>
       </Grid>
        {/* Filter area END */}

        <div className={classes.tblOuterBG}>
          <TableContainer className={classes.tblContainer}>
            <Table size="small" stickyHeader aria-label="sticky table">
              <TableHead className={classes.tblHeader}>
                <TableRow>
                  <TableCell>
                    <Checkbox></Checkbox>
                  </TableCell>
                  {tableColumnData &&
                    tableColumnData.map((column, index) => {
                      return <TableCell>{column.name}</TableCell>;
                    })}
                  <TableCell align="center" style={{ width: "165px" }}>
                    {translation.master_table_actions}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={classes.tblBody}>
                {tableRowData &&
                  tableRowData.map((row, index) => {
                    return (
                      <TableRow key={row.id}>
                        <TableCell>
                          <Checkbox></Checkbox>
                        </TableCell>
                        <TableCell>{row.subCategoryCode}</TableCell>
                        <TableCell>{row.subcategoryName}</TableCell>
                        <TableCell>{row.companyCode}</TableCell>
                        <TableCell>{row.accountGroupCode} </TableCell>
                        <TableCell>
                          <Checkbox value={row.isActive}></Checkbox>{" "}
                        </TableCell>
                        <TableCell align="center">
                          <div className={classes.editBtn}>
                            <button onClick={(e) => onEditClick(row)}>
                              <EditIcon></EditIcon>
                              <span className={classes.editBtnTxt}>
                                {translation.master_table_editbtntxt}
                              </span>
                            </button>
                          </div>
                          <div className={classes.rejectBtn}>
                            <button onClick={(e) => onDeleteClick(row)}>
                              <HighlightOffOutlinedIcon></HighlightOffOutlinedIcon>
                              <span className={classes.rejectBtnTxt}>
                                {translation.master_table_deletebtntxt}
                              </span>
                            </button>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[]}
            component="div"
            count={rowCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
          ></TablePagination>
        </div>
      </div>
      <div>
        {" "}
        <AccSubCategoryAddDialog
          open={isUpdateOpen}
          dataObj={selectedData}
          setDataObj={setSelectedData}
          handleClose={handleUpdateDialogClose}
        ></AccSubCategoryAddDialog>
      </div>
    </div>
  );
}
